<div fxFlex fxLayout="column" class="centered">
  <img class="maintenance-icon " alt="Maintenance image" src="assets/images/maintenance.svg">
  <br/>
  <p class="maintenance-message">{{message}}</p>
</div>
